// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BundleCard_bundle-card__W3aKe {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.BundleCard_bundle-card__details-container__9DZyu {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.BundleCard_bundle-card__image-container__lcsfo {
  border: 0.1rem solid var(--black-ten-opacity);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  height: 35rem;
  padding: 1.3rem;
}

.BundleCard_bundle-card__image-container__lcsfo:hover {
  box-shadow: 0px 4px 14px 0px var(--black-15-opacity);
}

.BundleCard_bundle-card__image-list__oHatS {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.BundleCard_bundle-card__image-list--only-one__E5Yf9 {
  display: block;
  height: 100%;
}

.BundleCard_bundle-card__image-list--only-one__E5Yf9 .BundleCard_bundle-card__image-list-item__nIKmh {
  width: 100%;
  height: 100%;
  border: none;
}

.BundleCard_bundle-card__image-list-item__nIKmh {
  height: 16rem;
  border: 0.1rem solid var(--black-ten-opacity);
  border-radius: 0.8rem;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.BundleCard_bundle-card__image-list-item--more__rpZDQ {
  height: 12rem;
}

.BundleCard_bundle-card__image__E\\+Ywg {
  max-height: 100%;
  object-fit: contain;
}

.BundleCard_bundle-card__more-link__coCtG {
  flex-shrink: 0;
  margin-top: auto;
  width: 100%;
  height: 7rem;
  border-radius: 0.8rem;
  background: var(--sky);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6rem;
}

.BundleCard_bundle-card__more-details__cM9nY {
  color: var(--primary-color);
  font-size: var(--text-lg);
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.BundleCard_bundle-card__more-quantity__JljLH {
  font-weight: 600;
}

.BundleCard_bundle-card__more-text__bDJV9 {
  font-weight: 700;
}

.BundleCard_bundle-card__title__rxusv {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 1rem;
}

.BundleCard_bundle-card__name__6yGnz {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
  display: block;
  margin-bottom: 1rem;
}

.BundleCard_bundle-card__footer__jV2ZX {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.BundleCard_bundle-card__price-wrapper__pXLOU {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  color: var(--primary-color);
  font-weight: 700;
}

.BundleCard_bundle-card__price__YGEXY {
  font-size: var(--text-2xl);
}

.BundleCard_bundle-card__price-currency__HfGF1 {
  font-size: var(--text-xl);
}

.BundleCard_bundle-card__add-to-cart-btn__hz5I\\+ {
  width: 100%;
  padding-block: 1.9rem;
  justify-content: center;
}

.BundleCard_bundle-card__quantity-wrapper__hiFDW {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.BundleCard_bundle-card__quantity-controls__RiGce {
  max-width: 40%;
}
`, "",{"version":3,"sources":["webpack://./src/components/BundleCard/BundleCard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".bundle-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.bundle-card__details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n}\n\n.bundle-card__image-container {\n  border: 0.1rem solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n  height: 35rem;\n  padding: 1.3rem;\n}\n\n.bundle-card__image-container:hover {\n  box-shadow: 0px 4px 14px 0px var(--black-15-opacity);\n}\n\n.bundle-card__image-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.bundle-card__image-list--only-one {\n  display: block;\n  height: 100%;\n}\n\n.bundle-card__image-list--only-one .bundle-card__image-list-item {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.bundle-card__image-list-item {\n  height: 16rem;\n  border: 0.1rem solid var(--black-ten-opacity);\n  border-radius: 0.8rem;\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bundle-card__image-list-item--more {\n  height: 12rem;\n}\n\n.bundle-card__image {\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.bundle-card__more-link {\n  flex-shrink: 0;\n  margin-top: auto;\n  width: 100%;\n  height: 7rem;\n  border-radius: 0.8rem;\n  background: var(--sky);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6rem;\n}\n\n.bundle-card__more-details {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n}\n\n.bundle-card__more-quantity {\n  font-weight: 600;\n}\n\n.bundle-card__more-text {\n  font-weight: 700;\n}\n\n.bundle-card__title {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n.bundle-card__name {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.bundle-card__footer {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.bundle-card__price-wrapper {\n  display: flex;\n  align-items: flex-end;\n  gap: 1rem;\n  color: var(--primary-color);\n  font-weight: 700;\n}\n\n.bundle-card__price {\n  font-size: var(--text-2xl);\n}\n\n.bundle-card__price-currency {\n  font-size: var(--text-xl);\n}\n\n.bundle-card__add-to-cart-btn {\n  width: 100%;\n  padding-block: 1.9rem;\n  justify-content: center;\n}\n\n.bundle-card__quantity-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bundle-card__quantity-controls {\n  max-width: 40%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bundle-card": `BundleCard_bundle-card__W3aKe`,
	"bundle-card__details-container": `BundleCard_bundle-card__details-container__9DZyu`,
	"bundle-card__image-container": `BundleCard_bundle-card__image-container__lcsfo`,
	"bundle-card__image-list": `BundleCard_bundle-card__image-list__oHatS`,
	"bundle-card__image-list--only-one": `BundleCard_bundle-card__image-list--only-one__E5Yf9`,
	"bundle-card__image-list-item": `BundleCard_bundle-card__image-list-item__nIKmh`,
	"bundle-card__image-list-item--more": `BundleCard_bundle-card__image-list-item--more__rpZDQ`,
	"bundle-card__image": `BundleCard_bundle-card__image__E+Ywg`,
	"bundle-card__more-link": `BundleCard_bundle-card__more-link__coCtG`,
	"bundle-card__more-details": `BundleCard_bundle-card__more-details__cM9nY`,
	"bundle-card__more-quantity": `BundleCard_bundle-card__more-quantity__JljLH`,
	"bundle-card__more-text": `BundleCard_bundle-card__more-text__bDJV9`,
	"bundle-card__title": `BundleCard_bundle-card__title__rxusv`,
	"bundle-card__name": `BundleCard_bundle-card__name__6yGnz`,
	"bundle-card__footer": `BundleCard_bundle-card__footer__jV2ZX`,
	"bundle-card__price-wrapper": `BundleCard_bundle-card__price-wrapper__pXLOU`,
	"bundle-card__price": `BundleCard_bundle-card__price__YGEXY`,
	"bundle-card__price-currency": `BundleCard_bundle-card__price-currency__HfGF1`,
	"bundle-card__add-to-cart-btn": `BundleCard_bundle-card__add-to-cart-btn__hz5I+`,
	"bundle-card__quantity-wrapper": `BundleCard_bundle-card__quantity-wrapper__hiFDW`,
	"bundle-card__quantity-controls": `BundleCard_bundle-card__quantity-controls__RiGce`
};
export default ___CSS_LOADER_EXPORT___;
